import 'Guide/entrypoint/guidepage';
import './home_page_hero';
import './featured_documents';
import 'Shared/Campaigns/campaign-banner-wp';
import { WPNewsletter } from 'Shared/newsletter';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

onDomReady(() => {
   document.querySelectorAll('.newsletter-sub').forEach(newsLetterEl => {
      new WPNewsletter(newsLetterEl, 'Homepage');
   });

   document.querySelectorAll('.js-product-ad').forEach(el => {
      el.addEventListener('click', () => {
         trackAnalyticsCustomEvent({
            eventCategory: 'Featured Products - Homepage',
            eventAction: `Featured on Homepage - ${el.get('data-ga-product')}`,
         });
      });
   });

   document.querySelectorAll('[data-ga-category]').forEach(el => {
      el.addEventListener('click', () => {
         trackAnalyticsCustomEvent({
            eventCategory: el.dataset.gaCategory,
            eventAction: el.dataset.gaAction,
         });
      });
   });
});
